/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { LastLocationProvider } from "react-router-last-location";
import { Routes } from "./app/router/Routes";
import { LayoutSplashScreen } from "./app/components/SplashScreen";
import { createTheme, CssBaseline, MuiThemeProvider, useMediaQuery } from "@material-ui/core";
import moment from "moment";
import "moment/locale/pt-br";

moment.locale("pt-br");

export default function App({ store, persistor, basename }) {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    const theme = createTheme({
        overrides: {
            MuiPickersDay: {
                day: { color: "#000" },
                daySelected: { backgroundColor: "#1976d2", color: "#fff" },
                current: { color: "#1976d2" },
            },
            MuiPickersCalendarHeader: {
                switchHeader: {
                    color: "#000",
                },
            },
            MuiPaper: {
                root: {
                    backgroundColor: "#fff",
                    color: "#000",
                },
            },
        },
    });

    return (
        <Provider store={store}>
            <MuiThemeProvider theme={theme}>
                <CssBaseline />
                <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
                    <React.Suspense fallback={<LayoutSplashScreen />}>
                        <BrowserRouter basename={basename}>
                            <LastLocationProvider>
                                <Routes />
                            </LastLocationProvider>
                        </BrowserRouter>
                    </React.Suspense>
                </PersistGate>
            </MuiThemeProvider>
        </Provider>
    );
}
